export class OrganizationUpdateRequest {
    name: string;
    identifier: string;
    businessName: string;
    billingEmail: string;
}
